import type { Language, Market, MarketMap } from "types";
import { LanguageTypes } from "types";

const DEFAULTS: { [key in MarketMap]: Language } = {
  US: LanguageTypes.en,
  SE: LanguageTypes.sv,
  GB: LanguageTypes.en,
  UK: LanguageTypes.en,
};

export const getDefaultLng = (region: Market): Language => {
  return DEFAULTS[region] || LanguageTypes.en;
};
